import { createActionCreator } from '../utils/helpers';

import {
  dismissActivity,
  fundingSearchActivities,
  triggerActivityAction,
  completeActivity,
  uploadDocuments,
  removeDocument,
  OPEN_COLLECTIVE_ACTIVITIES_MODAL,
  CLOSE_COLLECTIVE_ACTIVITIES_MODAL,
  COLLECTIVE_ACTIVITIES_MODAL_FILTER_UPDATED,
  collectiveActivities,
} from './types';

export const requestFundingSearchActivities = createActionCreator(
  fundingSearchActivities.request,
  'fundingSearchId',
);
export const requestFundingSearchActivitiesSuccess = createActionCreator(
  fundingSearchActivities.success,
  'response',
);
export const requestFundingSearchActivitiesFailure = createActionCreator(
  fundingSearchActivities.failure,
  'error',
);

export const requestDismissActivity = createActionCreator(
  dismissActivity.request,
  'fundingSearchId',
  'activityId',
  'metaData',
);
export const requestDismissActivitySuccess = createActionCreator(
  dismissActivity.success,
  'activityId',
  'response',
);
export const requestDismissActivityFailure = createActionCreator(
  dismissActivity.failure,
  'activityId',
  'error',
);

export const requestTriggerActivityAction = createActionCreator(
  triggerActivityAction.request,
  'fundingSearchId',
  'activityId',
  'feedbackType',
  'promise',
);
export const requestTriggerActivityActionSuccess = createActionCreator(
  triggerActivityAction.success,
  'activityId',
  'response',
);
export const requestTriggerActivityActionFailure = createActionCreator(
  triggerActivityAction.failure,
  'activityId',
  'error',
);

export const requestCompleteActivity = createActionCreator(
  completeActivity.request,
  'fundingSearchId',
  'activityId',
  'documents',
  'metaData',
);
export const requestCompleteActivitySuccess = createActionCreator(
  completeActivity.success,
  'activityId',
  'response',
);
export const requestCompleteActivityFailure = createActionCreator(
  completeActivity.failure,
  'activityId',
  'error',
);

export const requestUploadDocuments = createActionCreator(
  uploadDocuments.request,
  'identifier',
  'fundingSearchId',
  'activityId',
  'documentType',
  'files',
  'metaData',
);
export const requestUploadDocumentsSuccess = createActionCreator(
  uploadDocuments.success,
  'activityId',
  'documents',
);

export const requestRemoveDocument = createActionCreator(
  removeDocument.request,
  'fundingSearchId',
  'activityId',
  'documentId',
);
export const requestRemoveDocumentSuccess = createActionCreator(
  removeDocument.success,
  'activityId',
  'documentId',
);

export const openCollectiveActivitiesModal = createActionCreator(
  OPEN_COLLECTIVE_ACTIVITIES_MODAL,
  'filters',
);
export const closeCollectiveActivitiesModal = createActionCreator(
  CLOSE_COLLECTIVE_ACTIVITIES_MODAL,
);

export const updateCollectiveActivitiesModalFilter = createActionCreator(
  COLLECTIVE_ACTIVITIES_MODAL_FILTER_UPDATED,
  'filters',
);

export const requestCollectiveActivities = createActionCreator(collectiveActivities.request);
export const requestCollectiveActivitiesSuccess = createActionCreator(
  collectiveActivities.success,
  'response',
);
export const requestCollectiveActivitiesFailure = createActionCreator(
  collectiveActivities.failure,
  'error',
);
